import { createAction, handleActions } from 'redux-actions';
import { createSelfDefaultSchedule } from '../../../../util/campaignScheduleUtil';

// action types
const SET_NAME = 'selfMessage/SET_NAME';
const SET_RCV_TYPE = 'selfMessage/SET_RCV_TYPE';
const SET_BILLING_TYPE = 'selfMessage/SET_BILLING_TYPE';
const SET_RCS_TYPE = 'selfMessage/SET_RCS_TYPE';
export const setName = createAction(SET_NAME);
export const setRcvType = createAction(SET_RCV_TYPE);
export const setBillingType = createAction(SET_BILLING_TYPE);
export const setrcsType = createAction(SET_RCS_TYPE);

const SET_COUPON_LIST = 'selfMessage/SET_COUPON_LIST';
const SET_PACKAGE = 'selfMessage/SET_PACKAGE';
const SET_SELECTED_COUPON = 'selfMessage/SET_SELECTED_COUPON';
const SET_CASH_AMOUNT = 'selfMessage/SET_CASH_AMOUNT';
const SET_FREE_AMOUNT = 'selfMessage/SET_FREE_AMOUNT';
const SET_TXT_MESSAGE_UNIT = 'selfMessage/SET_TXT_MESSAGE_UNIT';
const SET_IMG_MESSAGE_UNIT = 'selfMessage/SET_IMG_MESSAGE_UNIT';
export const setCouponList = createAction(SET_COUPON_LIST);
export const setPackage = createAction(SET_PACKAGE);
export const setSelectedCoupon = createAction(SET_SELECTED_COUPON);
export const setCashAmount = createAction(SET_CASH_AMOUNT);
export const setFreeAmount = createAction(SET_FREE_AMOUNT);
export const setTxtMessageUnit = createAction(SET_TXT_MESSAGE_UNIT);
export const setImgMessageUnit = createAction(SET_IMG_MESSAGE_UNIT);

const SET_RCSFILE = 'selfMessage/SET_RCSFILE';
const SET_MMSFILE = 'selfMessage/SET_MMSFILE';
const SET_IMG_NAME = 'selfMessage/SET_IMG_NAME';
const SET_PREVIEW = 'selfMessage/SET_PREVIEW';
const SET_HOWMANY = 'selfMessage/SET_HOWMANY';
const SET_SELECETED = 'selfMessage/SET_SELECETED';
export const setRCSFile = createAction(SET_RCSFILE, (index, value) => ({ index, value }));
export const setMMSFile = createAction(SET_MMSFILE);
export const setImgName = createAction(SET_IMG_NAME);
export const setPreview = createAction(SET_PREVIEW);
export const setHowmany = createAction(SET_HOWMANY);
export const setSlideNM = createAction(SET_SELECETED)



const SET_IS_TMP = 'selfMessage/SET_IS_TMP';
export const setIsTmp = createAction(SET_IS_TMP);

const SET_RCS_INFO = 'selfMessage/SET_RCS_INFO';
const SET_RCS_INFO_TITLE = 'selfMessage/SET_RCS_INFO_TITLE';
const SET_RCS_INFO_MSG = 'selfMessage/SET_RCS_INFO_MSG';
const SET_RCS_INFO_IMG_ORIG_ID = 'selfMessage/SET_RCS_INFO_IMG_ORIG_ID';
const SET_BUTTONS = 'selfMessage/SET_BUTTONS';
const UPDATE_BUTTON = 'selfMessage/UPDATE_BUTTON';
const SET_URL_COUNT = 'selfMessage/SET_URL_COUNT';
const SET_RCS_URL = 'selfMessage/SET_RCS_URL';
const UPDATE_RCS_URL = 'selfMessage/UPDATE_RCS_URL';
const SET_BUTTONS_FOR_REMIND = 'selfMessage/SET_BUTTONS_FOR_REMIND';
export const setRcsInfo = createAction(SET_RCS_INFO);
export const setRcsInfoTitle = createAction(SET_RCS_INFO_TITLE, (title, index) =>({title, index}));
export const setRcsInfoMsg = createAction(SET_RCS_INFO_MSG, (msg, index) =>({msg, index}));
export const setRcsInfoImgOrigId = createAction(SET_RCS_INFO_IMG_ORIG_ID, (value, index)=>({ value, index }));
export const setButtons = createAction(SET_BUTTONS, (buttons, index) => ({ buttons, index }));
export const setButtonsForRemind = createAction(SET_BUTTONS_FOR_REMIND, (index, buttons) => ({index, buttons}));
export const updateButton = createAction(UPDATE_BUTTON, (button, buttonIndex, rcsIndex) => ({ button, buttonIndex, rcsIndex }));
export const setUrlCount = createAction(SET_URL_COUNT, (urlCount) => ({ urlCount }));
export const setRcsUrl = createAction(SET_RCS_URL, (url, index) => ({ url, index }));
export const updateRcsUrl = createAction(UPDATE_RCS_URL, (url, index, rcsIndex) => ({ url, index, rcsIndex }));

const SET_MMS_INFO_DEFAULT = 'selfMessage/SET_MMS_INFO_DEFAULT';
const SET_MMS_INFO = 'selfMessage/SET_MMS_INFO';
const SET_MMS_TITLE = 'selfMessage/SET_MMS_TITLE';
const SET_MMS_MSG = 'selfMessage/SET_MMS_MSG';
const SET_MMS_SETURL = 'selfMessage/SET_MMS_SETURL';
const SET_MMS_UPDATEURL = 'selfMessage/SET_MMS_UPDATEURL';
const SET_MMS_FILE_ORIG_ID = 'selfMessage/SET_MMS_FILE_ORIG_ID';
export const setMmsInfo = createAction(SET_MMS_INFO_DEFAULT);
export const setMms = createAction(SET_MMS_INFO);
export const setMmsTitle = createAction(SET_MMS_TITLE);
export const setMmsMsg = createAction(SET_MMS_MSG);
export const setMmsUrl = createAction(SET_MMS_SETURL);
export const updateMmsUrl = createAction(SET_MMS_UPDATEURL, (url, index) => ({ url, index }));
export const setMmsFileOrigId = createAction(SET_MMS_FILE_ORIG_ID, (origId, index) => ({ origId, index }));

const SET_TARGET_TYPE = 'selfMessage/SET_TARGET_TYPE';
const SET_MAPTICS_SEND_TYPE = 'selfMessage/SET_MAPTICS_SEND_TYPE';
const SET_COLL_START_DAY = 'selfMessage/SET_COLL_START_DAY';
const SET_COLL_END_DAY = 'selfMessage/SET_COLL_END_DAY';
const SET_COLL_SND_DAY = 'selfMessage/SET_COLL_SND_DAY';
const SET_RT_END_HOUR = 'selfMessage/SET_RT_END_HOUR';
const SET_RT_END_MINUTE = 'selfMessage/SET_RT_END_MINUTE';
const SET_SCHEDULE = 'selfMessage/SET_SCHEDULE';
const SET_MAPTICS_DATA = 'selfMessage/SET_MAPTICS_DATA';
const SET_MAPTICS_TARGET_ID = 'selfMessage/SET_MAPTICS_TARGET_ID';
export const setTargetType = createAction(SET_TARGET_TYPE);
export const setMapticsSendType = createAction(SET_MAPTICS_SEND_TYPE);
export const setCollStartDate = createAction(SET_COLL_START_DAY);
export const setCollEndDate = createAction(SET_COLL_END_DAY);
export const setCollSndDate = createAction(SET_COLL_SND_DAY);
export const setRtEndHour = createAction(SET_RT_END_HOUR);
export const setRtEndMinute = createAction(SET_RT_END_MINUTE);
export const setSchedule = createAction(SET_SCHEDULE);
export const setMapticsData = createAction(SET_MAPTICS_DATA);
export const setMapticsTargetId = createAction(SET_MAPTICS_TARGET_ID);

const SET_AGE_FROM = 'selfMessage/SET_AGE_FROM';
const SET_AGE_TO = 'selfMessage/SET_AGE_TO';
const SET_SND_NUM = 'selfMessage/SET_SND_NUM';
const SET_SND_GOAL_CNT = 'selfMessage/SET_SND_GOAL_CNT';
const SET_ATS_SND_START_DATE = 'selfMessage/SET_ATS_SND_START_DATE';
export const setSndNum = createAction(SET_SND_NUM);
export const setSndGoalCnt = createAction(SET_SND_GOAL_CNT);
export const setAtsSndStartDate = createAction(SET_ATS_SND_START_DATE);
export const setAgeFrom = createAction(SET_AGE_FROM);
export const setAgeTo = createAction(SET_AGE_TO);

const SET_SND_MOSU = 'selfMessage/SET_SND_MOSU';
const SET_SND_MOSU_QUERY = 'selfMessage/SET_SND_MOSU_QUERY';
const SET_SND_MOSU_DESC = 'selfMessage/SET_SND_MOSU_DESC';
const SET_SND_MOSU_JSON = 'selfMessage/SET_SND_MOSU_JSON';
export const setMosuCnt = createAction(SET_SND_MOSU);
export const setMosuQuery = createAction(SET_SND_MOSU_QUERY);
export const setMosuDesc = createAction(SET_SND_MOSU_DESC);
export const setMosuJson = createAction(SET_SND_MOSU_JSON);


const SET_MESSAGE_TYPE = 'selfMessage/SET_MESSAGE_TYPE';
const SET_RCS_TYPE_FIELD = 'selfMessage/SET_RCS_TYPE_FIELD';
export const setMessageType = createAction(SET_MESSAGE_TYPE);
export const setRcsType = createAction(SET_RCS_TYPE_FIELD);


const SET_FILES = 'selfMessage/SET_FILES';
const SET_FILE_COUNT = 'selfMessage/SET_FILE_COUNT';
export const setFiles = createAction(SET_FILES);
export const setFileCount = createAction(SET_FILE_COUNT);

const SET_INITIAL = 'selfMessage/SET_INITIAL';
export const setInitialState = createAction(SET_INITIAL);

const SET_REWARD_URL = 'selfMessage/SET_REWARD_URL';
export const setRewardUrl = createAction(SET_REWARD_URL);

const SET_CREATED_CAMPAIGN_UID = 'selfMessage/SET_CREATED_CAMPAIGN_UID';
export const setCreatedCampaignUid = createAction(SET_CREATED_CAMPAIGN_UID);

const SET_AI_CREATED = 'selfMessage/SET_AI_CREATED';
export const setAiCreated = createAction(SET_AI_CREATED);

const SET_IS_NAVER_LOGIN_ADDED = 'selfMessage/SET_IS_NAVER_LOGIN_ADDED';
const SET_NAVER_REDIRECT_URL = 'selfMessage/SET_NAVER_REDIRECT_URL';
const SET_NAVER_LOGIN_TEXT = 'selfMessage/SET_NAVER_LOGIN_TEXT';
export const setIsNaverLoginAdded = createAction(SET_IS_NAVER_LOGIN_ADDED);
export const setNaverRedirectUrl = createAction(SET_NAVER_REDIRECT_URL);
export const setNaverLoginText = createAction(SET_NAVER_LOGIN_TEXT);

const defaultSchedule = createSelfDefaultSchedule();

const initialState = {
    name: '',

    targetType: defaultSchedule.targetType,
    mapticsSendType: defaultSchedule.mapticsSendType,
    collStartDate: defaultSchedule.collStartDate,
    collEndDate: defaultSchedule.collEndDate,
    collSndDate: defaultSchedule.collSndDate,
    rtEndHour: defaultSchedule.rtEndHour,
    rtEndMinute: defaultSchedule.rtEndMinute,
    mapticsData: {
        address: '',
        gender: '0',
        minAge: 0,
        maxAge: 0,
        radius: 0,
        stayMin: 0,
        stadiumId: 0,
    },
    mapticsTargetId: 0,

    rcvType: 0,
    billingType: 1,
    rcsType: 51,

    couponList: [],
    userPackage: null,
    selectedCoupon: {},
    cashAmount: 0,
    freeAmount: 0,
    txtMessageUnit: 120,
    imgMessageUnit: 140,

    RCSInfo: [{
        slideNum: 1,
        title: '',
        msg: '',
        imgOrigId: '',
        urlLink: {
            list: []
        },
        buttons: {
            list:[]
        },
        opts: {}
    }],

    MmsInfo: {
        title: '',
        msg: '',
        fileInfo: {
            list: [
                {origId: ''}
            ]
        },
        urlLink: {
            list: []
        }
    },

    urlCount: [],

    callback: '16700823',
    sndNum: '001001',
    sndGoalCnt: 1000,
    atsSndStartDate: defaultSchedule.atsSndStartDate,

    ageTo: 50,
    ageFrom: 20,
    mosuCnt: 0,
    mosuQuery: '',
    mosuDesc: '',
    mosuJson: '',

    messageType: '일반 문자메시지-이미지',
    RCSType: '이미지',

    RCSFile: [null],
    MMSFile: null,
    imgName: '',

    rewardUrl: null,

    howmany:[1],
    selectedSlide: 1,

    files: [],
    fileCount:0,

    createdCampaignUid: 0,

    aiCreated: false,

    isNaverLoginAdded: 'N',
    naverRedirectUrl: '',
    naverLoginText: '',
}


// reducer
export default handleActions({
    [SET_NAME]: (state, action) => ({ ...state, name: action.payload }),
    [SET_RCV_TYPE]: (state, action) => ({ ...state, rcvType: action.payload }),
    [SET_BILLING_TYPE]: (state, action) => ({ ...state, billingType: action.payload }),
    [SET_RCS_TYPE]: (state, action) => ({ ...state, rcsType: action.payload }),

    [SET_COUPON_LIST]: (state, action) => ({
        ...state, couponList: action.payload
    }),
    [SET_PACKAGE]: (state, action) => ({
        ...state, userPackage: action.payload
    }),
    [SET_SELECTED_COUPON]: (state, action) => ({
        ...state, selectedCoupon: action.payload
    }),
    [SET_CASH_AMOUNT]: (state, action) => ({
        ...state, cashAmount: action.payload
    }),
    [SET_FREE_AMOUNT]: (state, action) => ({
        ...state, freeAmount: action.payload
    }),
    [SET_TXT_MESSAGE_UNIT]: (state, action) => ({
        ...state, txtMessageUnit: action.payload
    }),
    [SET_IMG_MESSAGE_UNIT]: (state, action) => ({
        ...state, imgMessageUnit: action.payload
    }),

    [SET_HOWMANY]: (state, action) => ({...state, howmany: action.payload }),
    [SET_SELECETED]: (state, action) => ({...state, selectedSlide: action.payload }),

    /*RCSInfo, MMSInfo 변경 해야함*/
    [SET_RCS_INFO]: (state, action) => ({ ...state, RCSInfo: action.payload }),
    // RCSInfo (type : []) map을 통해 루프가 돌면서 payload에 담긴 index와 동일하면 변경, 아니면 기존 데이터
    // 기본적으로 ...(spread)연산자를 통해 변경되지 않는 데이터 지속적으로 저장
    [SET_RCS_INFO_TITLE]: (state, action) => {
        const { index, title } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? { ...info, title: title } : info
            )
        }
    },
    [SET_RCS_INFO_MSG]: (state, action) => {
        const { index, msg } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? { ...info, msg: msg } : info
            )
        }
    },
    [SET_RCS_INFO_IMG_ORIG_ID]: (state, action) => {
        const { index, value } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? {...info, imgOrigId: value} : info
            )
        }
    },
    /*버튼 정보 입력 받기*/
    // RCS 슬라이드 별 button 길이 지정 1개 선택 => [{}], 2개 선택 => [{},{}]
    [SET_BUTTONS]: (state, action) => {
        const { index, buttons } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? { ...info, buttons: { list: buttons } } : info
            )
        };
    },
    [SET_BUTTONS_FOR_REMIND]: (state, action) => {
        const { index, buttons } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? { ...info, buttons: { list: buttons } } : info
            )
        };
    },
    // 사용자가 버튼 갯수를 선택했을때 이미 buttons.list 길이 정해져 있음
    // rcsIndex, buttonIndex 로 버튼정보 변경
    [UPDATE_BUTTON]: (state, action) => {
        const { button, buttonIndex, rcsIndex } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === rcsIndex ? {
                    ...info, buttons: {
                        list: info.buttons.list.map((btn, idx) => idx === buttonIndex ? button : btn)
                    }
                } : info
            )
        };
    },
    /*RCS URL (위 SET_BUTTONS, UPDATE_BUTTON 과 동일 로직)*/
    [SET_URL_COUNT]: (state, action) => {
        const { urlCount } = action.payload;
        return {
            ...state, urlCount: urlCount
        }
    },
    [SET_RCS_URL]: (state, action) => {
        const { url, index } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === index ? { ...info, urlLink: { list: url } } : info
            )
        };
    },
    [UPDATE_RCS_URL]: (state, action) => {
        const { url, index, rcsIndex } = action.payload;
        return {
            ...state,
            RCSInfo: state.RCSInfo.map((info, i) =>
                i === rcsIndex ? {
                    ...info, urlLink: {
                        list: info.urlLink.list.map((btn, idx) => idx === index ? url : btn)
                    }
                } : info
            )
        };
    },
    [SET_MMS_INFO]: (state, action) => ({ ...state, MmsInfo: action.payload }),

    [SET_MMS_INFO_DEFAULT]: (state, action) => (
        { ...state,
            MmsInfo: {
                title: '',
                msg: '',
                fileInfo: {
                    list: [
                        {origId: ''}
                    ]
                },
                urlLink: {
                    list: []
                }
            }
        }),
    [SET_MMS_TITLE]: (state, action) => ({...state, MmsInfo: {...state.MmsInfo, title:action.payload}}),
    [SET_MMS_MSG]: (state, action) => ({...state, MmsInfo: {...state.MmsInfo, msg:action.payload}}),
    /*MMS URL*/
    [SET_MMS_SETURL]: (state, action) => {
        return {
            ...state,
            MmsInfo: { ...state.MmsInfo, urlLink: {list: action.payload}}
        };
    },
    [SET_MMS_UPDATEURL]: (state, action) => {
        const { url, index } = action.payload;
        return {
            ...state,
            MmsInfo: { ...state.MmsInfo, urlLink: {list: state.MmsInfo.urlLink.list.map((u, idx) => idx === index ? url : u)}}
        };
    },
    [SET_MMS_FILE_ORIG_ID]: (state, action) => {
        const { origId, index } = action.payload;
        return {
            ...state,
            MmsInfo: {
                ...state.MmsInfo,
                fileInfo: {
                    ...state.MmsInfo.fileInfo,
                    list: state.MmsInfo.fileInfo.list.map((file, i) =>
                        i === index ? { ...file, origId } : file
                    )
                }
            }
        };
    },

    [SET_TARGET_TYPE]: (state, action) => ({ ...state, targetType: action.payload }),
    [SET_MAPTICS_SEND_TYPE]: (state, action) => ({ ...state, mapticsSendType: action.payload }),
    [SET_COLL_START_DAY]: (state, action) => ({ ...state, collStartDate: action.payload }),
    [SET_COLL_END_DAY]: (state, action) => ({ ...state, collEndDate: action.payload }),
    [SET_COLL_SND_DAY]: (state, action) => ({ ...state, collSndDate: action.payload }),
    [SET_RT_END_HOUR]: (state, action) => ({ ...state, rtEndHour: action.payload }),
    [SET_RT_END_MINUTE]: (state, action) => ({ ...state, rtEndMinute: action.payload }),
    [SET_SCHEDULE]: (state, action) => ({ ...state, ...action.payload }),
    [SET_MAPTICS_DATA]: (state, action) => ({ ...state, mapticsData: action.payload }),
    [SET_MAPTICS_TARGET_ID]: (state, action) => ({ ...state, mapticsTargetId: action.payload }),

    [SET_SND_NUM]: (state, action) => ({ ...state, sndNum: action.payload }),
    [SET_SND_GOAL_CNT]: (state, action) => ({ ...state, sndGoalCnt: action.payload }),
    [SET_ATS_SND_START_DATE]: (state, action) => ({ ...state, atsSndStartDate: action.payload }),


    [SET_AGE_FROM]: (state, action) => ({...state, ageFrom: action.payload }),
    [SET_AGE_TO]: (state, action) => ({...state, ageTo: action.payload }),
    [SET_SND_MOSU]: (state, action) => ({ ...state, mosuCnt: action.payload }),
    [SET_SND_MOSU_QUERY]: (state, action) => ({ ...state, mosuQuery: action.payload }),
    [SET_SND_MOSU_DESC]: (state, action) => ({ ...state, mosuDesc: action.payload }),
    [SET_SND_MOSU_JSON]: (state, action) => ({ ...state, mosuJson: action.payload }),

    [SET_MESSAGE_TYPE]: (state, action) => ({ ...state, messageType: action.payload }),
    [SET_RCS_TYPE_FIELD]: (state, action) => ({ ...state, RCSType: action.payload }),


    [SET_FILES]: (state, action) => ({ ...state, files: action.payload }),
    [SET_FILE_COUNT]: (state, action) => ({ ...state, fileCount: action.payload }),
    [SET_RCSFILE]: (state, action) => {
        const { index, value } = action.payload;
        return {
            ...state,
            RCSFile: state.RCSFile.map((info, i) =>
                i === index ? value : info
            )
        }
    },
    [SET_MMSFILE] : (state, action) => {
        return { ...state, MMSFile: action.payload }
    },
    [SET_IMG_NAME]: (state, action) => ({ ...state, imgName: action.payload }),

    [SET_INITIAL] : () => initialState,

    [SET_REWARD_URL]: (state, action) => ({ ...state, rewardUrl: action.payload }),

    [SET_CREATED_CAMPAIGN_UID]: (state, action) => ({ ...state, createdCampaignUid: action.payload }),

    [SET_AI_CREATED]: (state, action) => ({ ...state, aiCreated: action.payload }),

    [SET_IS_NAVER_LOGIN_ADDED]: (state, action) => ({ ...state, isNaverLoginAdded: action.payload }),
    [SET_NAVER_REDIRECT_URL]: (state, action) => ({ ...state, naverRedirectUrl: action.payload }),
    [SET_NAVER_LOGIN_TEXT]: (state, action) => ({ ...state, naverLoginText: action.payload }),
}, initialState);
